import { createRoute, createRouter } from '@tanstack/react-router';
import { LandingPage } from '../../components/LandingPage';
import { devToolsRoute } from '../../routes/devtools';
import { deploymentRouteTree } from '../../routes/deployment';
import { securityRouteTree } from '../../routes/security';
import { serviceRegistryRouteTree } from '../../routes/service-registry';
import { systemRouteTree } from '../../routes/system';
import { testingRouteTree } from '../../routes/testing';
import type { NavigationPath } from '../../routes/navigation';
import { rootRoute } from './rootRoute';
import type { BreadcrumbPath, RouteBreadcrumb, RouteBreadcrumbPathHook, RouteLabelHook } from './routeMetadata';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    useBreadcrumbLabel?: RouteLabelHook;
    useDocumentTitlePrefix?: RouteLabelHook;
    breadcrumbTo?: BreadcrumbPath;
    useBreadcrumbTo?: RouteBreadcrumbPathHook;
    navigationPath?: NavigationPath;
    parentBreadcrumbs?: readonly RouteBreadcrumb[];
  }
}

const homeRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: LandingPage });

const routeTree = rootRoute.addChildren([
  homeRoute,
  serviceRegistryRouteTree,
  deploymentRouteTree,
  testingRouteTree,
  securityRouteTree,
  devToolsRoute,
  systemRouteTree,
]);

export const router = createRouter({ routeTree, basepath: import.meta.env.BASE_URL, scrollRestoration: true });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
